import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.space.SurveyStatus,
    graphql.schema.SurveyStatus
  >({
    [ents.extra.space.SurveyStatus.NotStarted]:
      graphql.schema.SurveyStatus.NotStarted,
    [ents.extra.space.SurveyStatus.InProgress]:
      graphql.schema.SurveyStatus.InProgress,
    [ents.extra.space.SurveyStatus.SignedOff]:
      graphql.schema.SurveyStatus.SignedOff,
  }),
  graphql.transformers.OUT.default(
    graphql.transformers.OUT.enumeration<
      graphql.schema.SurveyStatus,
      ents.extra.space.SurveyStatus
    >({
      [graphql.schema.SurveyStatus.NotStarted]:
        ents.extra.space.SurveyStatus.NotStarted,
      [graphql.schema.SurveyStatus.InProgress]:
        ents.extra.space.SurveyStatus.InProgress,
      [graphql.schema.SurveyStatus.SignedOff]:
        ents.extra.space.SurveyStatus.SignedOff,
    }),
    ents.extra.space.SurveyStatus.NotStarted,
  ),
)
